export const SkillsHistChartConfig = (
  formatTitle: (name: string, value: string) => string,
  title: string,
  data: string[]
) => ({
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    },
    formatter: ({ [0]: { name, value } }) => formatTitle(name, value)
  },
  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        title: title,
        backgroundColor: "transparent"
      }
    }
  },
  legend: {
    orient: "horizontal",
    bottom: 0
  },
  xAxis: {
    type: "category",
    data: data.map((p) => p["Skills per User"])
  },
  yAxis: {
    type: "value"
  },
  series: [
    {
      type: "bar",
      data: data.map((data) => data["Number of Users"]),
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)"
        }
      }
    }
  ]
});
